import { useAtom } from 'jotai';
import { toast } from 'sonner';

import { overlayAtom, snackbarStore } from '@/atoms-store/snackbar-store';
import { ErrorIcon, LoadingIcon, SuccessIcon } from './snackbar-icons';
import './snackbar.css';

interface SnackbarState {
	message: string;
	type: 'wait' | 'success' | 'error';
	count: number;
}

let toastId: string | number | undefined;
let state: SnackbarState = { message: '', type: 'wait', count: 0 };
let finalState: 'success' | 'error' | null = null;

const className = 'font-bold text-white border-0 shadow-sm bg-gradient-to-br from-slate-500 to-slate-600 dark:from-slate-300 dark:to-slate-100';

const updateToast = () => {
	let icon = LoadingIcon;
	let message = state.message;
	let duration = Infinity;

	if (state.count === 0 && finalState) {
		icon = finalState === 'success' ? SuccessIcon : ErrorIcon;
		message = finalState === 'success' ? 'Successfull' : 'Error occurred';
		duration = 3000;
	}

	toastId = toast(message, {
		id: toastId,
		position: 'bottom-left',
		richColors: false,
		duration,
		icon,
		className,
	});

	if (state.count === 0 && finalState) {
	snackbarStore.set(overlayAtom, false);
	// console.log('<---Dismissing toast  --->\n', state, finalState);
	setTimeout(() => {
		toast.dismiss(toastId);
		// snackbarStore.set(overlayAtom, false);
		// console.log('<---Dismissing toast 1 --->\n');
		finalState = null;
	}, 3000);
	}
	// console.log(`Toast updated - Count: ${state.count}, Message: ${message}, Final State: ${finalState}`);
};

const incrementCount = () => {
	state.count++;
	// console.log(`Count incremented to ${state.count}`);
};

const decrementCount = () => {
	if (state.count > 0) {
		state.count--;
	// console.log(`Count decremented to ${state.count}`);
	} else {
		console.warn('Attempted to decrement count below 0');
	}
};

const success = () => {
	incrementCount();
	state.message = 'Please wait...';
	state.type = 'wait';
	if (finalState !== 'error') finalState = 'success';
	updateToast();
//   snackbarStore.set(overlayAtom, true);
};

const error = () => {
	incrementCount();
	state.message = 'Please wait...';
	state.type = 'wait';
	finalState = 'error';
	updateToast();
//   snackbarStore.set(overlayAtom, true);
};

const clear = () => {
	decrementCount();
	updateToast();
};

const wait = (hideOverlay: boolean = false) => {
	if (!hideOverlay) {
		incrementCount();
		state.message = 'Please wait...';
		state.type = 'wait';
		updateToast();
		snackbarStore.set(overlayAtom, true);
	}
};

export const snackbar = {
	success,
	error,
	clear,
	wait,
};

const Snackbar = () => {
  const [overlay] = useAtom(overlayAtom);

  return (
	<>
	  {overlay && <div className="overlay"></div>}
	</>
  );
};

export default Snackbar;
